<div class="col-sm-12">

    <h3>Avaliar proposta parceria</h3>
    <hr>

    <div class="col-sm-12">

        <div class="col-sm-12">
            <br>
            <h3>Proposta:</h3>
            <hr>
            <div class="col-sm-12">
                <p><span style="color: #999;">Entidade concedente:</span><b>
                        {{ dispensaInexigibilidade.entidadeConcedente.nome }} </b> </p>
                <p><span style="color: #999;">Tipo de processo:</span><b>
                        {{ dispensaInexigibilidade.tipoProposta }}</b> </p>
                <p><span style="color: #999;">Título:</span> <b>{{ dispensaInexigibilidade.titulo }}</b></p>
                <hr>
                <span style="color: #999;">
                    <p>Descrição:</p>
                </span>
                <div [innerHtml]="dispensaInexigibilidade.descricao"></div>

                <hr>
                <p><span style="color: #999;">Valor:</span><b> {{ planoTrabalho.et2Valor | currency: 'BRL':'symbol-narrow':'1.2-2' }}</b></p>
                <p><span style="color: #999;">Valor por extenso: </span><b>{{ planoTrabalho.et2ValorExtenso }}</b></p>
                <p><span style="color: #999;">Unidade orçamentária:</span><b> {{ planoTrabalho.et2UnidadeOrcamentaria}}</b></p>
                <p><span style="color: #999;">Fonte:</span><b> {{ planoTrabalho.et2Fonte}}</b></p>
                <p><span style="color: #999;">Dotação orçamentária:</span><b> {{ planoTrabalho.et2DotacaoOrcamentaria}}</b></p>
                <p><span style="color: #999;">Elemento despesa:</span><b> {{ planoTrabalho.et2ElementoDespesa}}</b></p>
                <hr>

                <p><span style="color: #999;">Anexos: </span></p>
                <div *ngFor="let anexo of anexosSalvos">
                    <a style="cursor: pointer;" (click)="openModalAnexo(anexo)"> {{anexo.proposta}}</a>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <br>
            <h3>Avaliação:</h3>
            <hr>

            <div class="col-sm-12">
                <div class="form-group col-sm-6" style="padding-left: 0;">
                    <Label>Ação:</Label>
                    <select name="select" class="form-control">
                        <option value="1">Ação 1</option>
                        <hr>
                        <option value="">Todos</option>
                    </select>
                </div>
                <div class="form-group col-sm-6">
                    <Label>Produto:</Label>
                    <select name="select" class="form-control">
                        <option value="1">Produto 1</option>
                        <hr>
                        <option value="">Todos</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Defina a situação da proposta:</label>
                    <div class="radio">
                        <label>
                            <input type="radio" name="optionsRadios" (click)="aprovado()" id="optionsRadios2"> Aprovado
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <input type="radio" name="optionsRadios" (click)="reprovado()" id="optionsRadios3">
                            Reprovado
                        </label>
                    </div>
                </div>
                <p-editor [(ngModel)]="avaliacao.justificativa" placeholder="Justificativa...">
                </p-editor>
                <br>
            </div>
        </div>

        <div class="col-sm-12">
            <hr>
            <button class="btn btn-success btn-sm" (click)="salvar()">SALVAR AVALIAÇÃO</button>
        </div>

    </div>

</div>


<p-dialog [style]="{width: '800px'}" header="{{nomeAnexo}}" [(visible)]="displayAnexo" showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3>Anexo</h3>
        <hr>
    </div>
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>